/**
 * @taskId T650
 * @taskId T651
 * @see functional/Cycles/cycle-5/tasks.md HU-25-FE
 */
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import {
  fetchDashboardKpis,
  DEFAULT_PERIOD,
  toValidPeriod,
  type DashboardPeriod,
  type DashboardKpiResponse,
} from '../api';

const STALE_TIME = 60_000;        // 1 minuto — T650
const REFETCH_INTERVAL = 300_000; // 5 minutos — T650

export function useDashboardData() {
  const [period, setPeriod] = useState<DashboardPeriod>(DEFAULT_PERIOD);

  // T651: setter con guardia — solo acepta períodos válidos
  const handleSetPeriod = (next: DashboardPeriod) => {
    setPeriod(toValidPeriod(next));
  };

  const query = useQuery<DashboardKpiResponse, Error>({
    queryKey: ['bo', 'dashboard', 'kpis', period],
    queryFn: () => fetchDashboardKpis(period),
    staleTime: STALE_TIME,
    refetchInterval: REFETCH_INTERVAL,
    refetchOnWindowFocus: false,
  });

  return {
    ...query,
    period,
    setPeriod: handleSetPeriod,
  };
}
